import axios from '@/utils/requset'

const api = {
  getListByCode: { url: '/base/dict/getListByCode', method: 'post' },
  enableListByCode: { url: '/base/dict/getEnableListByCode', method: 'post' }
}

export function enableListByCode({ dictCode }) {
  return axios({ ...api.enableListByCode, data: new URLSearchParams({ dictCode }) })
}

export function getListByCode({ dictCode }) {
  return axios({ ...api.getListByCode, data: new URLSearchParams({ dictCode }) })
}